import { Pressable, PressableProps, StyleProp, ViewStyle } from "react-native";
import Animated, {
	runOnJS,
	useAnimatedStyle,
	useReducedMotion,
	useSharedValue,
	withTiming,
} from "react-native-reanimated";
import isTouchDevice from "src/constants/isTouchDevice";

const DEFAULT_TARGET_SCALE = isTouchDevice ? 0.96 : 1;

const AnimatedPressable = Animated.createAnimatedComponent(Pressable);

// Original source https://mozzius.dev/post/3l777nhz4h32w
const TouchableScale = ({
	targetScale = DEFAULT_TARGET_SCALE,
	children,
	style,
	animatedStyle,
	onPressIn,
	onPressOut,
	...rest
}: {
	targetScale?: number;
	style?: StyleProp<ViewStyle>;
	animatedStyle?: StyleProp<ViewStyle>;
} & Exclude<PressableProps, "onPressIn" | "onPressOut" | "style">) => {
	const reducedMotion = useReducedMotion();

	const scale = useSharedValue(1);

	const animatedScaleStyle = useAnimatedStyle(
		() => ({
			transform: [{ scale: scale.value }],
		}),
		[scale],
	);

	return (
		<AnimatedPressable
			accessibilityRole="button"
			onPressIn={(event) => {
				"worklet";
				if (onPressIn) {
					runOnJS(onPressIn)(event);
				}
				scale.value = withTiming(targetScale, { duration: 100 });
			}}
			onPressOut={(event) => {
				"worklet";
				if (onPressOut) {
					runOnJS(onPressOut)(event);
				}
				scale.value = withTiming(1, { duration: 100 });
			}}
			style={[style, animatedStyle, !reducedMotion && animatedScaleStyle]}
			{...rest}
		>
			{children}
		</AnimatedPressable>
	);
};
export default TouchableScale;
